import React, {useEffect, useState} from "react"
import {graphql, PageProps} from "gatsby"
import {H1} from "../components/common/h1";
import {Navigation} from "../components/navigation/";
import {Layout} from "../components/common/layout";
import {BreadCrumbList} from "../components/common/breadCrumbList";
import {Option} from "../components/option";
import {Toc} from "../components/toc";
import {QuestionMarkCircleIcon} from "@heroicons/react/24/solid";

const Slug: React.FunctionComponent<PageProps<GatsbyTypes.SlugQuery>> = ({data}) => {
    const {markdownRemark} = data // data.markdownRemark holds your post data
    const {frontmatter, html, tableOfContents} = markdownRemark!;

    const str = frontmatter?.slug
    const directory = str?.split('/')[1] ? str?.split('/')[1] : '';
    const option = frontmatter!.option || false;
    const toc = frontmatter!.toc || false;
    const desc = frontmatter?.description ? frontmatter?.description : undefined

    const [isFixed, setIsFixed] = useState(false)
    useEffect(() => setIsFixed(window.innerHeight > document.body.offsetHeight))

    const hasSideMenu = (directory !== "faq") && (directory !== "news");

    const FaqContents = () => {
        return (
            <div>
                <H1 className="flex items-start"><QuestionMarkCircleIcon width="1.5em"
                                                                         className="text-primary-300 mr-4"/>{frontmatter!.title}
                </H1>
            </div>
        );
    }

    if (hasSideMenu) {
        return (
            <Layout title={frontmatter!.title!} description={desc} footerFixed={isFixed}>
                    <div className="flex justify-center gap-12">
                        <Navigation directory={directory}/>
                        <article className="w-3/4 mb-8">
                            <BreadCrumbList directory={directory}/>
                            <H1>{frontmatter!.title}<Option option={option}/></H1>
                            {toc && tableOfContents ? <Toc toc={tableOfContents} /> : ''}
                            <div className="post mt-16" dangerouslySetInnerHTML={{__html: html!}}/>
                        </article>
                    </div>
            </Layout>)
    } else {
        return (
            <Layout title={frontmatter!.title!} description={desc} footerFixed={isFixed}>
                <section className="grid grid-cols-12">
                    <div className= "col-start-3 col-end-11">
                        <article className=" mb-8">
                            <BreadCrumbList directory={directory}/>
                            {directory === "faq" ? FaqContents() : <H1>{frontmatter!.title}</H1>}
                            <div className="post mt-16" dangerouslySetInnerHTML={{__html: html!}}/>
                        </article>
                    </div>
                </section>
            </Layout>
        )
    }
}

export default Slug;

export const pageQuery = graphql`
    query Slug($id: String) {
        markdownRemark(id: {eq: $id}) {
            html
            frontmatter {
                date(formatString: "MMMM DD, YYYY")
                slug
                title
                description
                option
                toc
            }
            tableOfContents(
                absolute: false
                maxDepth: 3
                pathToSlugField: "frontmatter.slug"
            )
    }
}

                `